// extracted by mini-css-extract-plugin
export default {"results__total":"SearchResults_results__total__Xxh4x","results__wrapper":"SearchResults_results__wrapper__9j6VK","results__loading":"SearchResults_results__loading__LVOua"};